import React, { useRef } from 'react';
import useFeatureFlag, { FEATURE_FLAGS } from 'flags/useFeatureFlag';
import { useSetBrazeLanguage } from '../../App/braze/setBrazeLanguage';
import Container from '../../Shared/Container';
import { HomeWelcomeModal } from '../WelcomeModal';
import { HomepageTodoList } from './TodoList';
import DailyBoostBanner from './DailyBoost/DailyBoostBanner';
import ForManagers from './ForManagers/ForManagers';
import Hero from './Hero/Hero';
import ShareFeedback from './ShareFeedback/ShareFeedback';
import SupportForYou from './SupportForYou/SupportForYou';
import TherapyAndCoaching from './TherapyAndCoaching/TherapyAndCoaching';
import ToolsForYourDay from './ToolsForYourDay/ToolsForYourDay';
import YourCourses from './YourCourses/YourCourses';
import './PersonalisedTodayScreen.scss';

const PersonalisedTodayScreen = () => {
  useSetBrazeLanguage();
  const modalCloseReturnRef = useRef<HTMLDivElement>(null);

  const isHomepageRedesignEnabled = useFeatureFlag(
    FEATURE_FLAGS.HOMEPAGE_REDESIGN_ENABLED,
  );

  const isHomepageOnboardingTodoListEnabled = useFeatureFlag(
    FEATURE_FLAGS.HOMEPAGE_ONBOARDING_TODOLIST_ENABLED,
  );

  return (
    <Container className="home-screen" ref={modalCloseReturnRef}>
      <Hero />
      {isHomepageOnboardingTodoListEnabled && <HomepageTodoList />}
      {!isHomepageRedesignEnabled && !isHomepageOnboardingTodoListEnabled && (
        <SupportForYou />
      )}
      {isHomepageRedesignEnabled && <TherapyAndCoaching />}
      {isHomepageRedesignEnabled && <ForManagers />}
      <YourCourses />
      <DailyBoostBanner />
      <ToolsForYourDay />
      <ShareFeedback />
      <HomeWelcomeModal />
    </Container>
  );
};

export default PersonalisedTodayScreen;
